<template>
    <div class="home-banner" :class="{ 'bg-linear': $route.name === 'HomePage' }">
        <img class="banner" :src="bannerSrc" alt="banner" />
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "Advertising",
    props: {
        bannerSrc: {
            type: String,
            default: require('@assets/img/home-banner.png')
        }
    }
};
</script>

<style lang="scss" scoped>
.home-banner {
    position: relative;
    width: 100%;
    height: 880px;

    .banner {
        width: 100%;
        height: 100%;
    }

    &.bg-linear:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        /* background: linear-gradient(to bottom, $defaultColor, transparent); */
    }
}
</style>